import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LogedUser } from './models/logged-user.model';
import { AuthSession } from './auth-flow/auth-session';
import { AUTH_SESSION } from './auth-flow/tokens';

export function canAccessDashboard(user: LogedUser | null | undefined): boolean {
  if (!user) {
    return false;
  }

  return (
    user.agency_modules?.includes('3') &&
    user.security?.dashboard === true &&
    !user.lite
  );
}

@Injectable({ providedIn: 'root' })
export class DashboardGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    @Inject(AUTH_SESSION) private readonly authSession: AuthSession,
  ) {}

  canActivate(): Promise<boolean | UrlTree> {
    // restoreSession resolves the user for the active login flow (new or legacy)
    return this.authSession
      .restoreSession()
      .then((user: LogedUser) => this.resolveAccess(user))
      .catch(() => this.router.createUrlTree(['/home']));
  }

  private resolveAccess(user: LogedUser): boolean | UrlTree {
    if (canAccessDashboard(user)) {
      return true;
    }

    return this.router.createUrlTree(['/home']);
  }
}
